/**
 *  Implement bundling functionality
 */
if (document.querySelector('[data-bundle-product]')) {
    var default_image = "";

    window.addEventListener('DOMContentLoaded', async function() {

        var bundle_products = document.querySelectorAll('[data-bundle-product]');
        default_image = document.querySelector('.main-product .product-gallery-item:first-of-type img');

        // Loop through all bundle products
        for (var i = 0; i < bundle_products.length; i++) {
            // Get product handle and variant id
            var product_handle = bundle_products[i].dataset.productHandle,
                variant_id = bundle_products[i].dataset.variantId;
            
            // Set some values if product handle and variant id exist
            if (product_handle !== "" && variant_id !== "") {
                var product_element = document.querySelector(`[data-variant-id="${variant_id}"]`);

                // Make call to get product information
                var product_data = await makeRequest('GET', `/products/${product_handle}.js`, null, 'application/json; charset=UTF-8');
                product_data = JSON.parse(product_data.response);

                // Set product image
                product_element.innerHTML = `
                    <img src="${imgURL(product_data.featured_image, 'small')}">
                `;

                // Make call to get variant information
                var variant_data = await makeRequest('GET', `/variants/${variant_id}.js`);
                variant_data = JSON.parse(variant_data.response);

                // Product title
                if (variant_data.title == "Default Title") {
                    var product_title = product_data.title;
                } else {
                    var product_title = `${variant_data.title} ${product_data.title}`;
                }

                // Product description info
                var product_description = product_data.description,
                    description_split = product_description.indexOf("<!-- split -->"),
                    product_description = product_description.substring(0, description_split != -1 ? description_split : product_description.length);

                // Set data attributes with variant/product title, price, sku and description
                product_element.setAttribute('data-product-title', `${product_title}`);
                product_element.setAttribute('data-product-price', `${variant_data.price}`);
                product_element.setAttribute('data-product-sku', `${variant_data.sku}`);
                product_element.setAttribute('data-product-description', `<p>${product_description}</p>`);
                product_element.setAttribute('data-product-available', `${variant_data.available}`);
                product_element.setAttribute('data-gtm-product-title', `${product_data.title}`);
                product_element.setAttribute('data-gtm-variant-title', `${variant_data.title}`);

                if (variant_data.available == false) {
                    product_element.setAttribute('data-available-text', KROWN.settings.locales.products_sold_out_variant);
                }
            }

            // Add click event listener to each bundle product
            bundle_products[i].addEventListener('click', function(e) {
                if (e.currentTarget.dataset.productAvailable != "false") {
                    clickBundle(e);
                }
            });

            if (i + 1 == bundle_products.length) {
                slideDown(document.querySelector('.product-bundling__wrapper'), 500);
            }
        }

        // Add event listener to add to cart button
        document.querySelector('[data-bundle-atc-bundle]').addEventListener('click', function(e) {
            addToCartBundle(e);
        });
    });
}

/**
 * clickBundle: Function triggered when user clicks on an item in the bundling functionality
 * @param {Object} event 
 */
async function clickBundle(event) {
    // Set up variables
    var product = event.currentTarget,
        // Get parent row info
        parent_row = product.parentNode.parentNode,
        parent_choice = parent_row.dataset.bundlingChoice,
        parent_row_index = index(parent_row),
        // Get bundling info
        bundling_type = parent_row.parentNode.dataset.bundlingType,
        bundling_rows = parent_row.parentNode.dataset.bundlingRows,
        // Get selected item info
        product_bundle = product.dataset.bundleProduct,
        product_handle = product.dataset.productHandle,
        variant_id = product.dataset.variantId,
        product_title = product.dataset.productTitle,
        product_price = product.dataset.productPrice,
        product_sku = product.dataset.productSku,
        product_description = product.dataset.productDescription,
        gtm_product_title = product.dataset.gtmProductTitle,
        gtm_variant_title = product.dataset.gtmVariantTitle,
        // Get currently selected item
        current_selected = document.querySelector(`[data-bundling-choice="${parent_choice}"] [data-bundle-product].selected`),
        // Get default product details
        default_product = document.querySelector('[data-product-data]'),
        default_title = default_product.getAttribute('data-product-title'),
        default_sku = default_product.getAttribute('data-product-sku'),
        default_price = default_product.getAttribute('data-product-price'),
        default_description = default_product.getAttribute('data-product-description'),
        shop_currency = default_product.getAttribute('data-shop-currency'),
        asset_placeholder = default_product.getAttribute('data-asset-string'),
        // Get elements where content will change
        title_element = document.querySelector(`[data-bundling-choice="${parent_choice}"] [data-product-name]`),
        sku_element = document.querySelector('.product__sku span'),
        price_element = document.querySelectorAll('.product__price--original'),
        description_element = document.querySelector('.product__description'),
        // Add to cart buttons
        default_button = document.querySelector('[data-bundle-atc-default]'),
        bundle_button = document.querySelector('[data-bundle-atc-bundle]');

    if (window.location.hostname.indexOf('ruma.co.uk') > -1) {
        if (product_bundle !== "default") {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'view_item',
                ecommerce: {
                    currency: shop_currency,
                    value: KROWN.helpers.formatMoney(parseInt(product_price), '{{amount}}').replace(',', ''),
                    items: [
                        {
                            item_name: gtm_product_title,
                            item_id: product_sku,
                            currency: shop_currency,
                            price: KROWN.helpers.formatMoney(parseInt(product_price), '{{amount}}').replace(',', ''),
                            item_variant: gtm_variant_title
                        }
                    ]
                }
            });
        }
    }

    if (bundling_type === "conditional") {
        if (product_bundle !== "default") {
            var next_parent_row = parent_row.nextElementSibling;
            if (next_parent_row !== null && next_parent_row.classList.contains('product-bundling__row')) {
                slideDown(next_parent_row, 500);
            }
        } else {
            if (parent_row_index + 1 < bundling_rows) {
                var product_rows = document.querySelectorAll('.product-bundling__row');
                for (var i = parent_row_index + 1; i < product_rows.length; i++) {
                    slideUp(product_rows[i], 500);
                    product_rows[i].querySelector(`[data-bundle-product].selected`).classList.remove('selected');
                    product_rows[i].querySelector(`[data-bundle-product="default"]`).classList.add('selected');
                    product_rows[i].querySelector(`[data-product-name]`).innerHTML = product.innerHTML;
                }
            }
        }
    }

    // Change selected element
    current_selected.classList.remove('selected');
    product.classList.add('selected');

    // Update title of product which appears next to "Add item?"
    if (product_bundle !== "default") {
        title_element.innerHTML = product_title;
    } else {
        title_element.innerHTML = product.innerHTML;
    }

    // Update elements with new values
    var new_price = parseInt(default_price);
    var new_sku = default_sku;
    var new_description = `<p>${default_description}</p>`;
    var showBundleButton = false;
    var new_image = default_sku;

    var selected_choices = document.querySelectorAll('[data-bundle-product].selected');
    Array.prototype.forEach.call(selected_choices, function(el, i){
        if (el.dataset.bundleProduct !== "default") {
            new_price += parseInt(el.dataset.productPrice);
            new_sku += " / " + el.dataset.productSku;
            new_description += "<p><strong>" + el.dataset.productTitle + "</strong></p><p>" + el.dataset.productDescription + "</p>";
            showBundleButton = true;
            new_image += `-${el.dataset.productSku}`
        }
    });

    // Change price element
    price_element.forEach(function(price_e) {
        price_e.innerHTML = KROWN.helpers.formatMoney(
            parseInt(new_price), 
            '£{{amount}}'
        );
    });

    // Change SKU element
    sku_element.innerHTML = new_sku;

    // Change description element
    description_element.innerHTML = new_description;

    // Change visible button
    if (showBundleButton) {
        default_button.style.display = "none";
        bundle_button.style.display = "block";

        document.querySelectorAll('.product__price--compare').forEach(function(comparePrice) {
            comparePrice.style.display = "none";
        });
    } else {
        bundle_button.style.display = "none";
        default_button.style.display = "block";

        document.querySelectorAll('.product__price--compare').forEach(function(comparePrice) {
            comparePrice.style.display = "block";
        });
    }

    // Change image
    if (new_image.includes('-')) {
        var new_image_path = asset_placeholder.replace('imagefilename', new_image);
        var image_call = await makeRequest('GET', new_image_path);
        if (image_call.status == 200) {
            var new_image_element = `<img src="${new_image_path}">`;
            document.querySelector('.main-product .product-gallery-item:first-of-type').innerHTML = new_image_element;
            document.querySelector('.css-slider-dot-navigation .css-slider-dot:first-of-type').click();
        } else {
            document.querySelector('.main-product .product-gallery-item:first-of-type').appendChild(default_image);
        }
    } else {
        document.querySelector('.main-product .product-gallery-item:first-of-type').appendChild(default_image);
    }
}

async function addToCartBundle(event) {
    event.preventDefault();

    var quantity = document.querySelector('.product__quantity').value,
        base_variant_id = document.querySelector('[data-type="add-to-cart-form"] input[name="id"]').value;

    var data = {
        items: [
            {
                id: base_variant_id,
                quantity: quantity
            }
        ]
    };

    var selected_choices = document.querySelectorAll('[data-bundle-product].selected');
    Array.prototype.forEach.call(selected_choices, function(el, i){
        if (el.dataset.bundleProduct !== "default") {
            var choice_data = {
                id: el.dataset.variantId,
                quantity: quantity
            }
            data.items.push(choice_data);
        }
    });

    // Send data object to cart/add.js to add the items to cart
    var add_to_cart = await makeRequest('POST', '/cart/add.js', JSON.stringify(data), 'application/json; charset=UTF-8');

    if (add_to_cart) {
        if (window.location.hostname.indexOf('ruma.co.uk') > -1) {
            var default_product = document.querySelector('[data-product-data]'),
                default_gtm_product_title = default_product.getAttribute('data-gtm-product-title'),
                default_gtm_variant_title = default_product.getAttribute('data-gtm-variant-title'),
                default_sku = default_product.getAttribute('data-product-sku'),
                default_price = default_product.getAttribute('data-product-price'),
                shop_currency = default_product.getAttribute('data-shop-currency'),
                quantity = document.querySelector(`[name="quantity"]`).value,
                total_price = parseInt(default_price),
                selected_items = [{
                    item_name: default_gtm_product_title,
                    item_id: default_sku,
                    currency: "GBP",
                    price: KROWN.helpers.formatMoney(
                        parseInt(default_price), 
                        '{{amount}}'
                    ).replace(',', ''),
                    quantity: quantity,
                    item_variant: default_gtm_variant_title
                }];
                
            Array.prototype.forEach.call(selected_choices, function(el, i){
                if (el.dataset.bundleProduct !== "default") {
                    total_price += parseInt(el.dataset.productPrice);

                    selected_items.push({
                        item_name: el.dataset.gtmProductTitle,
                        item_id: el.dataset.productSku,
                        currency: shop_currency,
                        price: KROWN.helpers.formatMoney(
                            parseInt(el.dataset.productPrice), 
                            '{{amount}}'
                        ).replace(',', ''),
                        quantity: quantity,
                        item_variant: el.dataset.gtmVariantTitle
                    });
                }
            });

            var total = quantity * total_price;

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    currency: shop_currency,
                    value: total,
                    items: selected_items
                }
            });
        }

        // After the items have been added to the cart, make a call to the cart-helper section to get the cart contents now the new items have been added
        var cart_contents = await makeRequest('GET', '?section_id=cart-helper');

        const sectionInnerHTML = new DOMParser().parseFromString(cart_contents.response, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
        window.preloadImages(cartItems);

        document.querySelector('[data-header-cart-count]').textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;

        document.getElementById('site-cart').show();
    }
}